<template>
  <!-- Dialogo para indicar errores -->
  <v-dialog
    v-model="alertaVideoDescuento.estatus"
    persistent
    max-width="400"
  >
    <v-card>
      <v-card-text class="pt-8">
        <video id="video" 
          v-if="getEscuela == 2" 
          src="https://fastenglish.com.mx/public/images/fast_descuento.mp4"
          frameborder="0" 
          allowfullscreen
          controls
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          style="width: 100%; height: 100%; background: #FFFFFF;" allowtransparency="true">
        </video>

        <video id="video" 
          v-if="getEscuela == 1" 
          src="https://inbi.mx/public/images/inbi_descuento.mp4"
          frameborder="0" 
          allowfullscreen
          controls
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          style="width: 100%; height: 100%; background: #FFFFFF;" allowtransparency="true">
        </video>
      </v-card-text>
      <v-card-actions>
        <v-btn
          block
          dark
          color="blue"
          @click="abrirRutaPago( ), alertaVideoDescuento.estatus = false"
        >
          PAGAR AHORA
        </v-btn>
      </v-card-actions>

      <v-speed-dial
        top
        right
        absolute
        class="mb-4 me-n4 mt-n4"
      >
        <template v-slot:activator>
          <v-btn
            icon
            fab
            small
            @click="alertaVideoDescuento.estatus = false"
          >
            <v-icon>
              mdi-close
            </v-icon>
          </v-btn>
        </template>
      </v-speed-dial>
    </v-card>
  </v-dialog>
</template>


<script>
  // Importar lebrerías
  import { mapGetters, mapActions } from 'vuex'
  import { Clipboard } from '@capacitor/clipboard';
  // import { Share } from '@capacitor/share';


  export default {
    props:[
      'alertaVideoDescuento'
    ],

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getGrupos', 'getEscuela' ]),
    },

    methods:{
      async abrirRutaPago( ){
        window.open(this.alertaVideoDescuento.ruta_pago)
      }
    }
  }
</script>

